import ContainerForm from 'components/ContainerForm';
import { ContainerSection } from 'components/container-section/style';
import { InputTitle } from 'components/input/InputTitle';
import { StatusTag } from 'components/tag/StatusTag';
import { Row, Spacing, Typography } from 'enable-ui';

import { HeaderDetailPage } from 'modules/dashboard/components/HeaderDetailPage';

import { Container } from '../styles/full-time-detail';

import { COLOR } from 'constants/color';

import { AvatarTrainer } from '../component/Avatar';
import { TrainerPasswordForm } from '../component/TrainerPasswordForm';
import { TrainerProfileForm } from '../component/TrainerProfileForm';
import { useFullTimeDetailController } from '../core/controller/full-time-detail';

export const FullTimeDetailPage = () => {
  const {
    isView,
    trainer,
    email,
    level,
    name,
    password,
    phone,
    levels,
    disabled,
    gender,
    onCancel,
    handleSubmit,
    onChangeLevel,
    handleChange,
    onChangeGender,
    handleChangePhone,
    goBack,
    firstName,
    lastName,
    logoRef,
    logoURL,
    onChangeAvatar,
    onDeleteLogo,
    emailStatus,
    confirmPassword,
    handleConfirmPassword,
  } = useFullTimeDetailController();

  if (!trainer) {
    return <></>;
  }

  return (
    <ContainerForm
      disabledCancel={disabled}
      disabled={disabled}
      onCancel={onCancel}
      onSubmit={handleSubmit}
      titleSubmit="Save"
      titleCancel="Cancel changes"
    >
      <Container direction="column">
        <Spacing spacing="3xl" type="margin" placement="bottom">
          <HeaderDetailPage title="Trainer Details" goBack={goBack} style={{ marginBottom: 0 }} />
        </Spacing>
        <Row direction="row">
          <AvatarTrainer
            logoRef={logoRef}
            logoURL={logoURL.value}
            onChangeAvatar={onChangeAvatar}
            onDeleteLogo={onDeleteLogo}
          />
          <Row direction="column">
            <ContainerSection>
              <Row
                direction="column"
                style={{
                  width: 800,
                }}
              >
                <Spacing spacing="md" type="margin" placement="bottom">
                  <Typography
                    variant="h4"
                    weight={600}
                    color={COLOR.surfaceNeutralBold['neutral-11']}
                  >
                    General
                  </Typography>
                </Spacing>
                <Row>
                  <Row
                    direction="column"
                    style={{
                      width: 'fit-content',
                      marginRight: 100,
                    }}
                  >
                    <InputTitle title="Status" />
                    <StatusTag isActive={trainer?.isActive} />
                  </Row>
                  {/* <Row direction="column">
                <InputTitle title="Email" />
                <Row
                  align="center"
                  style={{
                    height: 32,
                  }}
                >
                  <Typography variant="body-1">{trainer?.email || ''}</Typography>
                </Row>
              </Row> */}
                </Row>
              </Row>
            </ContainerSection>
            <ContainerSection>
              <TrainerProfileForm
                gender={gender}
                name={name}
                phone={phone}
                level={level}
                levels={levels}
                onChangeLevel={onChangeLevel}
                handleChangePhone={handleChangePhone}
                handleChange={handleChange}
                onChangeGender={onChangeGender}
                firstName={firstName}
                lastName={lastName}
                email={email}
                emailStatus={emailStatus}
              />
            </ContainerSection>

            <ContainerSection>
              <TrainerPasswordForm
                password={password || ''}
                handleChange={handleChange}
                hasConfirmPassword
                styles={{ width: 800, borderTop: 'none', marginTop: 0, paddingTop: 0 }}
                confirmPassword={confirmPassword.value}
                handleConfirmPassword={handleConfirmPassword}
              />
            </ContainerSection>
          </Row>
        </Row>
      </Container>
    </ContainerForm>
  );
};
